import * as yup from 'yup';
import type { ContractUploadFieldDef } from './getContractUploadFields';
import type { TypeFile } from '../step4/hooks/types';
import type { IFile } from '~/services/modules/contract/types';

export function buildContractFilesSchema(fields: ContractUploadFieldDef[]) {
  const shape: Record<string, yup.AnySchema> = {};

  fields.forEach((field) => {
    if (field.optional) return;
    shape[field.key] = yup.mixed().required(field.key);
  });

  return yup.object(shape);
}

export async function validateContractFiles(
  fields: ContractUploadFieldDef[],
  files: Partial<Record<TypeFile, IFile | null>>
): Promise<Record<TypeFile, boolean>> {
  const schema = buildContractFilesSchema(fields);
  const payload: Record<string, IFile | null> = {};

  fields.forEach((field) => {
    if (!field.optional) {
      payload[field.key] = files[field.key] ?? null;
    }
  });

  try {
    await schema.validate(payload, { abortEarly: false });
    return {} as Record<TypeFile, boolean>;
  } catch (error) {
    if (!(error instanceof yup.ValidationError)) {
      throw error;
    }

    const errors = {} as Record<TypeFile, boolean>;
    error.inner.forEach((inner) => {
      if (inner.path) {
        errors[inner.path as TypeFile] = true;
      }
    });
    return errors;
  }
}
